import { render } from "./footer.vue?vue&type=template&id=6914c63e"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=6914c63e&lang=css"

import exportComponent from "/home/collin/workspace/hitech05/main-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__